import { render, staticRenderFns } from "./PassiveInventory.vue?vue&type=template&id=92791572&"
import script from "./PassiveInventory.vue?vue&type=script&lang=js&"
export * from "./PassiveInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports